import { UncontrolledTooltip } from "reactstrap";
import React, { Component } from "react";
import PropTypes from "prop-types";


const Defaults = {
  TooltipPlacement: "top",
};
/**
* Renders a user-friendly message bar in single line with the type and message separated by a colon ':'
* @param {"top" | "bottom" | "left" | "right" |"auto"} props.placement -The placement of the tooltip. Can be one of: "top", "bottom", "left", "right", "auto".
* @param {string} props.tooltipText -  The text to display in the tooltip
* @param {string} props.className -  CSS class to apply styling to the tooltip element.
* @param {string} props.maxHeight -  Whether to set the tooltip's max-height to 100%.
* @param {string} props.maxWidth -  Whether to set the tooltip's max-width to 100%.
* @returns {JSX.Element} rendered component
*/
class TooltipContainer extends Component {
  static propTypes = {
    children: PropTypes.node,
    tooltipText: PropTypes.string.isRequired,
    placement: PropTypes.oneOf([
      "top",
      "bottom",
      "left",
      "right",
      "auto",
    ]),
    className: PropTypes.string,
    maxHeight: PropTypes.bool,
    maxWidth: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      id: "",
    };
  }

  componentDidMount() {
    this.setState({
      id: `${Math.floor(Math.random() * 100000000)}`,
    });
  }

  render() {
    let { props } = this;
    let { id } = this.state;
    const { tooltipText, placement, className, maxHeight, maxWidth } = props;
    let targetId = id ? `tooltip-text-id-${id}` : "";
    let style = {};
    maxHeight && (style.height = "100%")
    maxWidth && (style.width = "100%")
    return (
      <React.Fragment>
        <span data-testid="tooltip-container" style={style} id={targetId}>
          {props.children}
        </span>
        {targetId && tooltipText ? (
          <UncontrolledTooltip className={className} placement={placement ? placement : Defaults.TooltipPlacement} target={targetId}>
            {tooltipText}
          </UncontrolledTooltip>
        ) : null}
      </React.Fragment>
    );
  }
}

export default TooltipContainer;


// WEBPACK FOOTER //
// ./src/libraries/TooltipContainer/index.jsx